"use strict";

export function getConfig() {
  var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var values = arguments.length > 1 ? arguments[1] : undefined;
  if (typeof window === 'undefined') return;
  var config = null;

  if (window.__CUTTLE_CONFIG__) {
    config = window.__CUTTLE_CONFIG__;
  }

  if (!config) {
    return;
  }

  var obj = {};

  if (Object.prototype.toString.call(config) === '[object Array]') {
    config.forEach(function (item) {
      obj[item.name] = item.value || item.defaultValue;
    });
  } else if (Object.prototype.toString.call(config) === '[object Object]') {
    obj = config;
  }

  return obj[key];
}
export default getConfig;